import { render } from "./AgendaFileUpload.vue?vue&type=template&id=080be1c6"
import script from "./AgendaFileUpload.vue?vue&type=script&lang=ts"
export * from "./AgendaFileUpload.vue?vue&type=script&lang=ts"
script.render = render

export default script